module.exports = __webpack_public_path__ + "media/images/districts-aaad1904ac43eb32eee21250ef43ecb9.svg";